var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.3125C5.42637 1.3125 1.3125 5.42637 1.3125 10.5C1.3125 15.5736 5.42637 19.6875 10.5 19.6875C15.5736 19.6875 19.6875 15.5736 19.6875 10.5C19.6875 5.42637 15.5736 1.3125 10.5 1.3125ZM13.892 13.9904L12.5385 13.9843L10.5 11.5541L8.46357 13.9822L7.10801 13.9884C7.01777 13.9884 6.94395 13.9166 6.94395 13.8243C6.94395 13.7854 6.9583 13.7484 6.98291 13.7177L9.65098 10.539L6.98291 7.3623C6.95813 7.33225 6.94438 7.29462 6.94395 7.25566C6.94395 7.16543 7.01777 7.0916 7.10801 7.0916L8.46357 7.09775L10.5 9.52793L12.5364 7.0998L13.8899 7.09365C13.9802 7.09365 14.054 7.16543 14.054 7.25771C14.054 7.29668 14.0396 7.33359 14.015 7.36436L11.3511 10.541L14.0171 13.7197C14.0417 13.7505 14.0561 13.7874 14.0561 13.8264C14.0561 13.9166 13.9822 13.9904 13.892 13.9904Z",
    fill: "#F03C5A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.e9b5affbaa4bd084e1bd049e146f6043.svg";
export { ForwardRef as ReactComponent };